import { Outlet } from "react-router-dom";
import { AuthGuard } from "./AuthGuard";

/**
 * A route wrapper that ensures the user is authenticated
 * before allowing access to the child routes
 */
export function ProtectedRoute() {
  return (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  );
}
